module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/cv_3_pc_9c57edee33135726952224936230113c.jpg";